import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import produce from 'immer';
import { rmAPI } from 'api/rmAPI';

export const fetchRmPageStats = createAsyncThunk(
    'rm/fetchRmPageStats',
    async (params) => await rmAPI.fetchRmPageStats(params)
);

export const fetchRmTrendData = createAsyncThunk(
    'rm/fetchRmTrendData',
    async (params) => await rmAPI.fetchTrendData(params)
);

export const fetchRmPeerComparisonData = createAsyncThunk(
    'rm/fetchRmPeerComparisonData',
    async (params) => await rmAPI.fetchPeerComparisonData(params)
);

export const fetchRmInvestigationData = createAsyncThunk(
    'rm/fetchRmInvestigationData',
    async (params) => await rmAPI.fetchRmInvestigationData(params)
);

export const submitRmInvestigation = createAsyncThunk(
    'rm/submitRmInvestigation',
    async (params, thunkAPI) => {
        const response = await rmAPI.submitRmInvestigation(params);
        thunkAPI.dispatch(fetchRmInvestigationData(params.query));
        return response;
    }
);

export const fetchRmScoreDecomposition = createAsyncThunk(
    'rm/fetchRmScoreDecomposition',
    async (params) => await rmAPI.fetchRmScoreDecomposition(params)
);

const rmSlice = createSlice({
    name: 'rm',
    initialState: {
        stats: null,
        trendData: null,
        peerComparisonData: null,
        rmInvestigationData: null,
        statsFetched: false,
        trendDataFetched: false,
        peerComparisonDataFetched: false,
        rmInvestigationDataFetched: false,
        rmInvestigationSelected: null,
        rmInvestigationSubmitted: false,
        scoreDecompositionData: null
    },
    reducers: {
        updateRmInvestigation: (state, { payload }) =>
            produce(state, (draft) => {
                draft.rmInvestigationSelected = payload;
                draft.rmInvestigationSubmitted = false;
            })
    },
    extraReducers: (builder) => {
        builder.addCase(fetchRmPageStats.fulfilled, (state, { payload }) =>
            produce(state, (draft) => {
                const { rmStatsReporting } = payload;
                draft.stats = rmStatsReporting;
                draft.statsFetched = true;
            })
        );
        builder.addCase(
            fetchRmInvestigationData.fulfilled,
            (state, { payload }) =>
                produce(state, (draft) => {
                    const { rmInvestigationSummary } = payload;
                    draft.rmInvestigationData = rmInvestigationSummary;
                    draft.rmInvestigationDataFetched = true;
                })
        );
        builder.addCase(submitRmInvestigation.fulfilled, (state) =>
            produce(state, (draft) => {
                draft.rmInvestigationSubmitted = true;
                draft.rmInvestigationDataFetched = false;
            })
        );
        builder.addCase(fetchRmTrendData.fulfilled, (state, { payload }) =>
            produce(state, (draft) => {
                const { trendAnalysisChartData } = payload;
                draft.trendData = trendAnalysisChartData;
                draft.trendDataFetched = true;
            })
        );
        builder.addCase(
            fetchRmScoreDecomposition.fulfilled,
            (state, { payload }) => {
                return produce(state, (draft) => {
                    draft.scoreDecompositionData = payload.rmScoreDecomposition;
                });
            }
        );
        builder.addCase(
            fetchRmPeerComparisonData.fulfilled,
            (state, { payload }) =>
                produce(state, (draft) => {
                    const { peerComparisonChartData } = payload;
                    draft.peerComparisonData = peerComparisonChartData;
                    draft.peerComparisonChartDataFetched = true;
                })
        );
    }
});

const { actions, reducer: rmReducer } = rmSlice;
export const { updateRmInvestigation } = actions;
export default rmReducer;
